/* ARRAY - the ritual section. Bound by delegation on document: an inline script
   inside a Horizon section renders but never binds.

   IT DECIDES WHICH PHOTOS CAN BE CUT OUT. Nine ARRAY packshots in ten sit on
   pure white or on transparency, and those can be multiplied into the card's
   tinted panel so they read as cut-outs. The tenth is a lifestyle shot on a
   coloured ground, and multiplying THAT is what turned the side rail muddy. So
   each photo is measured rather than assumed: a ring of border pixels is
   sampled off a canvas, and only an all-white (or all-transparent) border earns
   .is-cut. Anything else - and any image that cannot be read at all - is framed
   instead. The safe answer is the fallback on every error path, deliberately.

   Shopify's CDN serves images with Access-Control-Allow-Origin:*, and the <img>
   carries crossorigin="anonymous", so the canvas is not tainted. If that ever
   changes, getImageData throws, the catch fires, and every product is framed -
   the section looks plainer but nothing breaks.

   THE VIEWED PRODUCT'S OWN CARD IS EXCLUDED FROM THE BUNDLE. Every card carries
   an add button, including the one for the product already on screen, so its
   button is marked data-rr-self. Without that exclusion the bar counts the
   viewed product twice - once from mine() and once from its own card - and a
   three-card shelf advertises "ADD ALL 4". Clicking it still adds that one
   product on its own; it is only the bundle maths that skips it.

   THE TOTAL FOLLOWS THE SHADE. The product section owns the variant picker, so
   this one watches [data-pdp-add]'s data-vid and re-prices from the variant map
   the section printed. If the product section is not on the page, it falls back
   to the variant rendered server-side.

   IT ONLY EVER ADDS WHAT IT COUNTED. A companion with shades to choose is a
   link, not a button, and carries no data-vid - so it is absent from the count,
   the total AND the bundle add. The number on the bar is always exactly what
   the button puts in the bag.

   THE ADD SPEAKS HORIZON: /cart/add.js with the drawer's section ids, then a
   cart:update event shaped like the theme's own product form, or the drawer
   never re-renders. */
(function () {
  if (window.__bdRitualBound) return;
  window.__bdRitualBound = true;

  var ROOT = '[data-bd-ritual]';

  function q(r, s) { return r.querySelector(s); }
  function qa(r, s) { return Array.prototype.slice.call(r.querySelectorAll(s)); }

  /* ---------- money, in the shop's own format ---------- */
  function money(root, cents) {
    var fmt = root.getAttribute('data-money') || '${{amount}}';
    var n = cents / 100;
    var parts = n.toFixed(2).split('.');
    var withSep = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace('{{amount_with_comma_separator}}', withSep.replace(/,/g, '.') + ',' + parts[1])
      .replace('{{amount_no_decimals}}', Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace('{{amount}}', withSep + '.' + parts[1])
      .replace(/<[^>]+>/g, '');
  }

  /* ---------- can this photo be knocked out? ---------- */
  function classify(img) {
    try {
      var S = 64;
      var c = document.createElement('canvas');
      c.width = S; c.height = S;
      var x = c.getContext('2d', { willReadFrequently: true });
      if (!x) return 'photo';
      x.drawImage(img, 0, 0, S, S);
      var d = x.getImageData(0, 0, S, S).data;
      var pts = [], i;
      for (i = 0; i < S; i += 4) { pts.push([i, 0], [i, S - 1], [0, i], [S - 1, i]); }
      var bad = 0;
      for (i = 0; i < pts.length; i++) {
        var o = (pts[i][1] * S + pts[i][0]) * 4;
        if (d[o + 3] < 24) continue;                  /* transparent - already cut out */
        var r = d[o], g = d[o + 1], b = d[o + 2];
        var lum = 0.2126 * r + 0.7152 * g + 0.0722 * b;
        var sat = Math.max(r, g, b) - Math.min(r, g, b);
        if (lum < 236 || sat > 28) bad++;
      }
      return bad <= 1 ? 'cut' : 'photo';
    } catch (e) {
      return 'photo';
    }
  }
  function dress(img) {
    if (img.__done) return;
    img.__done = true;
    img.classList.add(classify(img) === 'cut' ? 'is-cut' : 'is-photo');
  }
  function dressAll(root) {
    qa(root, '[data-rr-shot]').forEach(function (img) {
      if (img.complete && img.naturalWidth) dress(img);
      else img.addEventListener('load', function () { dress(img); }, { once: true });
      img.addEventListener('error', function () { img.__done = true; img.classList.add('is-photo'); }, { once: true });
    });
  }

  /* ---------- what the bundle costs right now ---------- */
  function priceMap(root) {
    if (root.__pm) return root.__pm;
    var el = q(root, '[data-rr-prices]');
    try { root.__pm = el ? JSON.parse(el.textContent) : {}; } catch (e) { root.__pm = {}; }
    return root.__pm;
  }
  function mine(root) {
    var pdp = document.querySelector('[data-pdp-add]');
    if (pdp && !pdp.disabled) {
      var v = parseInt(pdp.getAttribute('data-vid'), 10);
      var pm = priceMap(root);
      if (v && pm[v] != null) return { id: v, price: pm[v] };
    }
    var sv = parseInt(root.getAttribute('data-self-vid'), 10);
    if (!sv) return null;
    return { id: sv, price: parseInt(root.getAttribute('data-self-price'), 10) || 0 };
  }
  function bundle(root) {
    var items = [], sum = 0;
    var me = mine(root);
    if (me) { items.push(me); sum += me.price; }
    qa(root, '[data-rr-add][data-vid]').forEach(function (b) {
      if (b.hasAttribute('data-rr-self')) return;   /* mine() already counted it */
      var v = parseInt(b.getAttribute('data-vid'), 10);
      if (!v) return;
      var pr = parseInt(b.getAttribute('data-price'), 10) || 0;
      items.push({ id: v, price: pr });
      sum += pr;
    });
    var disc = parseInt(root.getAttribute('data-disc'), 10) || 0;
    var net = disc > 0 ? Math.round(sum * (100 - disc) / 100) : sum;
    return { items: items, sum: sum, net: net, n: items.length };
  }

  function paint(root) {
    var b = bundle(root);
    var cta = q(root, '[data-rr-cta]');
    var nettxt = money(root, b.net);

    var tot = q(root, '[data-rr-total]');
    if (tot) tot.textContent = nettxt;
    var was = q(root, '[data-rr-was]');
    if (was) was.textContent = money(root, b.sum);

    var cnt = q(root, '[data-rr-count]');
    if (cnt) {
      var tpl = b.n === 1 ? root.getAttribute('data-pieces-one') : root.getAttribute('data-pieces-many');
      cnt.textContent = (tpl || '').split('{n}').join(String(b.n));
    }
    if (cta) {
      cta.disabled = b.n < 2;
      var t = q(cta, '[data-rr-cta-t]');
      if (t && !cta.__busy) {
        t.textContent = (root.getAttribute('data-cta') || '').split('{n}').join(String(b.n)).split('{total}').join(nettxt);
      }
    }
  }

  /* ---------- add ---------- */
  function sectionIds() {
    var ids = [];
    var comps = document.querySelectorAll('cart-items-component');
    for (var i = 0; i < comps.length; i++) if (comps[i].dataset && comps[i].dataset.sectionId) ids.push(comps[i].dataset.sectionId);
    return ids;
  }
  function announce(root, qty, sections) {
    var ev;
    try {
      ev = new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: {}, sourceId: 'beyondads-ritual', data: { source: 'product-form-component', itemCount: qty, productId: root.getAttribute('data-product-id'), sections: sections || {} } }
      });
    } catch (e) { return; }
    document.dispatchEvent(ev);
  }
  function post(root, btn, items, labelSel, doneTxt) {
    if (!items.length || btn.disabled || btn.__busy) return;
    var label = labelSel ? q(btn, labelSel) : null;
    var was = label ? label.textContent : '';
    btn.__busy = true;
    btn.classList.add('is-busy');

    var body = { items: items.map(function (i) { return { id: i.id, quantity: 1 }; }) };
    var ids = sectionIds();
    if (ids.length) { body.sections = ids.join(','); body.sections_url = window.location.pathname; }

    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        btn.classList.remove('is-busy');
        if (!res || res.status >= 400 || res.errors) {
          if (label) label.textContent = 'NOT AVAILABLE';
          setTimeout(function () { if (label) label.textContent = was; btn.__busy = false; paint(root); }, 1800);
          return;
        }
        btn.classList.add('is-done');
        if (label) label.textContent = doneTxt;
        announce(root, items.length, res.sections);
        setTimeout(function () { btn.classList.remove('is-done'); if (label) label.textContent = was; btn.__busy = false; paint(root); }, 1800);
      })
      .catch(function () { btn.classList.remove('is-busy'); btn.__busy = false; });
  }

  /* ---------- delegation ---------- */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var root = e.target.closest(ROOT);
    if (!root) return;

    var one = e.target.closest('[data-rr-add]');
    if (one && one.tagName === 'BUTTON') {
      e.preventDefault();
      var v = parseInt(one.getAttribute('data-vid'), 10);
      if (v) post(root, one, [{ id: v }], '[data-rr-add-t]', 'ADDED');
      return;
    }
    var cta = e.target.closest('[data-rr-cta]');
    if (cta) {
      e.preventDefault();
      post(root, cta, bundle(root).items, '[data-rr-cta-t]', 'ADDED TO BAG');
    }
  });

  /* the product section owns the shade; follow it */
  function watchPdp(root) {
    var pdp = document.querySelector('[data-pdp-add]');
    if (!pdp || root.__watch || !window.MutationObserver) return;
    root.__watch = new MutationObserver(function () { paint(root); });
    root.__watch.observe(pdp, { attributes: true, attributeFilter: ['data-vid', 'disabled'] });
  }

  function init(root) {
    dressAll(root);
    watchPdp(root);
    paint(root);
  }
  function initAll() { qa(document, ROOT).forEach(init); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
